import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import CreditMemo, { CreditMemoDto } from "./CreditMemo"

export type CreditMemoPayload = {
    notes: string,
    internalNotes: string,
    amount: number,
    currency: string,
    contactId: string,
    deposit: {
        paymentType: string,
        paymentTypeId: string,
    }
    locationId: string,
}

class CreditMemoService {
    httpClient: HttpClient<CreditMemo, CreditMemoDto> = new HttpClient<CreditMemo, CreditMemoDto>(CreditMemo)

    async get(id: string) {
        return this.httpClient.get("/credit-memos/" + id)
    }

    async getCreditMemosFromQuoteId(id: string): Promise<CreditMemo[] | HttpError> {
        const res = await this.httpClient.get(`/quotes/${id}/credit-memos`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as CreditMemo[]
    }

    async post(payload : CreditMemoPayload) : Promise<CreditMemo | HttpError> {
        const res = await this.httpClient.post("/credit-memos", payload)

        if (isError(res)) {
            throw new Error(res.message)
        }

        return res as CreditMemo
    }
}

const instance = new CreditMemoService()
export default instance


// WEBPACK FOOTER //
// ./src/state/credit-memo/CreditMemoService.ts